import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoadableSaveableBoolean } from '../loadable-saveable-boolean';

export const STATE_USER_SUBSCRIBED_LISTS = 'subscribedLists';

export interface UserSubsubscribedListsState {
  [listId: string]: LoadableSaveableBoolean;
}

export const USER_SUBSCRIBED_LISTS_INITIAL_STATE: UserSubsubscribedListsState =
  {};

export const selectUserSubscribedListsState =
  createFeatureSelector<UserSubsubscribedListsState>(
    STATE_USER_SUBSCRIBED_LISTS,
  );

export const selectListSubscriptionStatus = (listId: string) =>
  createSelector(selectUserSubscribedListsState, state => state[listId]);

export function getInitialUserSubsubscribedListsState(): UserSubsubscribedListsState {
  return USER_SUBSCRIBED_LISTS_INITIAL_STATE;
}
